'use client'

import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import * as React from 'react'

import { cn } from '../../lib'

type Props = React.ComponentProps<typeof CheckboxPrimitive.Root>

/**
 * @deprecated Use Checkbox instead
 */
const CheckboxV1 = ({ className, ...props }: Props) => {
  const checkboxStyles = cn(
    // 기본 스타일
    'peer shrink-0 w-6 h-6 relative overflow-hidden',

    // 상태별 스타일
    'data-[state=unchecked]:text-gray-200',
    'data-[state=checked]:text-primary',

    // 포커스 및 비활성화 스타일
    'focus-visible:outline-none',
    'focus-visible:ring-1',
    'focus-visible:ring-ring',
    'disabled:cursor-not-allowed',
    'disabled:opacity-50',

    className,
  )

  return (
    <CheckboxPrimitive.Root className={checkboxStyles} {...props}>
      <CheckboxPrimitive.CheckboxIndicator forceMount className="left-0 top-0 absolute rounded-full">
        <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor">
          <circle cx="12" cy="12" r="11" fill="currentColor" />
          <path
            d="M8 12.5L10.4749 14.9749L16.1317 9.31802"
            fill="none"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </CheckboxPrimitive.CheckboxIndicator>
    </CheckboxPrimitive.Root>
  )
}

CheckboxV1.displayName = 'CheckboxV1'

export default CheckboxV1
